import React from "react";
import {
  Form,
  InputGroup,
  
} from "shards-react";

export default () => (
  <Form className="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
    <InputGroup seamless className="ml-3">
      
    </InputGroup>
  </Form>
);
